/**
 * apps/web/components/legal/LegalDocumentTracker.tsx
 *
 * Client Component — emite `legal_document_viewed` via wrapper canônico
 * `trackLegalDocumentViewed` após hidratação. Decisão D8 do ADR.
 * Único Client Component da feature.
 *
 * Princípio: zero scroll, time-on-page, ou conteúdo lido — privacy-respecting.
 * Apenas dispara um evento síncrono on mount com as 4 props canônicas
 * (`user_id`, `session_id`, `feature_flag_active`, `release` — auto-injetada
 * pelo wrapper) + as 6 props de domínio (METRICS_SPEC §3 Evento 2).
 */
'use client';

import * as React from 'react';
import { trackLegalDocumentViewed } from '@brisa/shared/observability';
import type { LegalDocumentSlug } from '@brisa/identity';

export interface LegalDocumentTrackerProps {
  document_slug: LegalDocumentSlug;
  document_version: string;
  is_archived: boolean;
  locale: 'pt' | 'es';
  is_authenticated: boolean;
  referrer_path: string | null;
  user_id: string;
  session_id: string;
  feature_flag_active: boolean;
}

export function LegalDocumentTracker(props: LegalDocumentTrackerProps): null {
  const {
    user_id,
    session_id,
    feature_flag_active,
    ...domain
  } = props;
  React.useEffect(() => {
    trackLegalDocumentViewed(domain, {
      user_id,
      session_id,
      feature_flag_active,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
